import { render, staticRenderFns } from "./DocumentUploaderDialog.vue?vue&type=template&id=40920784"
import script from "./DocumentUploaderDialog.vue?vue&type=script&lang=js"
export * from "./DocumentUploaderDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentUploaderDialog.vue?vue&type=style&index=0&id=40920784&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports